export default __webpack_public_path__ + "static/media/16.3305f3d9.webp";